import React, { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import Skeleton from "@material-ui/lab/Skeleton";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import ArtTrackIcon from "@material-ui/icons/ArtTrack";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import axios from "helpers/API";
import { errorBackendMsg, getPermisoDefinicion } from "helpers/helpers";
import TurnoPdf from "../admin/turnos/templatePdf/TurnoPdf";
import MsgGenericoAlerta from "./MsgGenericoAlerta";
import APIMensajeMUI from "./APIMensajeMUI";
import MsgConfirmacion from "./MsgConfirmacion";
import Aviso from "./Aviso";

function CardTurno({
  turno,
  setRefresh,
  refresh,
  puedePonerAsistir,
  puedeCancelar,
  puedeDescargarComprobante,
  puedePonerPendiente,
}) {
  const history = useHistory();
  const [turnos, setTurnos] = useState([]);
  const [filtroActivas, setFiltroActivas] = useState(true);
  const [datosTurno, setDatosTurno] = useState(null);
  const [pageSize, setPageSize] = React.useState(10);

  //FILTROS
  const [lugarOpt, setLugarOpt] = useState([]);
  const [servidorOpt, setServidorOpt] = useState([]);
  const [servicioOpt, setServicioOpt] = useState([]);
  const [bandasHorariasOpt, setBandasHorariasOpt] = useState([]);
  const [fechaDesde, setFechaDesde] = useState(null);
  const [fechaHasta, setFechaHasta] = useState(null);

  // MODALS
  const [modalExito, setModalExito] = useState(false);
  const [modalCancelar, setModalCancelar] = useState(false);
  const [msgCancelar, setMsgCancelar] = useState("");
  const [msgExito, setMsgExito] = useState("");
  const [aviso, setAviso] = useState(false);
  const [msgAviso, setMsgAviso] = useState(false);
  const [colorAviso, setColorAviso] = useState("success");

  const [idCancelar, setIdCancelar] = useState(null);
  const [dniCancelar, setDniCancelar] = useState(null);
  const [cargandoLista, setCargandoLista] = useState(true);

  //PERMISOS
  const [loadingPermisos, setLoadingPermisos] = useState(true);

  // API Mensaje
  const [mensajeError, setMensajeError] = useState("");
  const [showError, setShowError] = useState(false);

  //MENU TABLA
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [idMenu, setIdMenu] = React.useState(null);

  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setIdMenu(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIdMenu(null);
    setDatosTurno(null);
  };
  const parserJsonTemplate = (data) => {
    // verificarFomatoJsonBaseDatos(data);
    const dataTurno = {
      nombre: data.solicitante.nombreCompleto || "No especificado",
      dni: data.solicitante.dni || "No especificado",
      domicilio: data.solicitante.domicilio || "No especificado",
      lugar: data.solicitante.domicilio || "No especificado",
      servicio: data.turno.servicio || "No especificado",
      nroTurno: data.turno.nroTurno || "No especificado",
      fecha: data.turno.fecha || "No especificado",
      hora: data.turno.hora || "No especificado",
      leyenda: data.leyenda || "No especificado",
      conSuscriptor: data.solicitante.conSuscriptor || "No especificado",
    };

    return dataTurno;
  };

  const verificarFomatoJsonBaseDatos = (data) => {
    try {
      if (data.reqCondicionesGral) {
        JSON.parse(data.reqCondicionesGral);
      }
      if (data.leyenda) {
        JSON.parse(data.leyenda);
      }
      if (data.reqPrequirurgico) {
        JSON.parse(data.reqPrequirurgico);
      }
    } catch (error) {
      alert(
        "Formato Json inválido en Base de Datos. Comuníquese con el Administrador de Sistema"
      );
    }
  };

  const getTurnoReservado = (nroTurno, nroDoc) => {
    axios
      .post("/turnos/obtener", {
        nroTurno: nroTurno,
        nroDoc: nroDoc,
      })
      .then(function (response) {
        if (response.data) {
          if (response.data.error) {
            setShowError(true);
            setMensajeError(response.data.msg);
          } else {
            setDatosTurno(parserJsonTemplate(response.data));
          }
        } else {
          setShowError(true);
          setMensajeError(errorBackendMsg(response));
        }
      })
      .catch(function (error) {
        setShowError(true);
        setMensajeError(errorBackendMsg(error));
      });
  };

  const consultarTurnos = (filtros) => {
    axios
      .post("/turnos/listar", filtros)
      .then(function (response) {
        if (!response.data.error) {
          setTurnos(response.data);
          setCargandoLista(false);
        } else {
          setShowError(true);
          setMensajeError(response.data.msg);
        }
        //setIsLoading(false);
      })
      .catch(function (error) {});
  };

  const cambiarAsistir = (id, estado) => {
    axios
      .post("/turnos/asistio", { nroTurno: id, asistio: estado })

      .then(function (response) {
        if (!response.data.error) {
          setAviso(true);
          setColorAviso("success");
          setMsgAviso("Se ha cambiado el estado de turno");
          setRefresh(refresh + 1);
        } else {
          setAviso(true);
          setColorAviso("error");
          setMsgAviso(response.data.msg);
        }
      })
      .catch(function (error) {
        setShowError(true);
        setMensajeError(errorBackendMsg(error));
      });
  };

  const cancelarTurno = (id, dni) => {
    axios
      .post("/turnos/cancelar", { nroTurno: id, nroDoc: dni })
      .then(function (response) {
        if (!response.data.error) {
          setAviso(true);
          setColorAviso("success");
          setMsgAviso("Se ha cancelado correctamente el turno");
          // consultarTurnos(formik.values);
        } else {
          setAviso(true);
          setColorAviso("error");
          setMsgAviso(response.data.msg);
        }
      })
      .catch(function (error) {
        setShowError(true);
        setMensajeError(errorBackendMsg(error));
      });
  };
  return (
    <Grid item md={4}>
      {modalCancelar && (
        <MsgConfirmacion
          setVisible={setModalCancelar}
          titulo="Cancelar Turno"
          msg={"¿Desea cancelar el turno seleccionado?"}
          aceptar={() => {
            cancelarTurno(idCancelar, dniCancelar);
          }}
        />
      )}
      {modalExito && (
        <MsgGenericoAlerta
          setVisible={setModalExito}
          titulo="Se ha cancelado el turno"
          msg={msgExito}
        />
      )}
      <APIMensajeMUI
        mt={10}
        tipo="error"
        showMensaje={showError}
        setShowMensaje={setShowError}
        msg={mensajeError}
      />
      <Aviso
        onClose={() => setAviso(false)}
        mostrar={aviso}
        msg={msgAviso}
        color={colorAviso}
      />
      <Card style={{ height: 200 }}>
        <CardHeader
          avatar={<Avatar>{turno.solicitante.slice(0, 1)}</Avatar>}
          action={
            <>
              { (puedeCancelar ||
                puedeDescargarComprobante ||
                puedePonerAsistir ||
                puedePonerPendiente) && (
                  <IconButton
                    aria-label="settings"
                    onClick={(e) => handleClick(e, turno.id)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                )}
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={idMenu == turno.id}
                onClose={handleClose}
              >
                {puedeDescargarComprobante && (
                  <MenuItem
                    onClick={() => {
                      getTurnoReservado(turno.id, turno.dni);
                    }}
                  >
                    {idMenu == turno.id && datosTurno ? (
                      <TurnoPdf
                        nombreArchivo="comprobante.pdf"
                        data={datosTurno}
                      />
                    ) : (
                      "Descargar comprabante"
                    )}
                  </MenuItem>
                )}
                {!turno.asistio ? (
                  <>
                    {puedePonerAsistir && (
                      <MenuItem
                        onClick={() => {
                          handleClose();
                          cambiarAsistir(turno.id, true);
                        }}
                      >
                        Marcar como asistido
                      </MenuItem>
                    )}
                  </>
                ) : (
                  <>
                    {puedePonerPendiente && (
                      <MenuItem
                        onClick={() => {
                          handleClose();
                          cambiarAsistir(turno.id, false);
                        }}
                      >
                        Marcar como pendiente
                      </MenuItem>
                    )}
                  </>
                )}
                {puedeCancelar && (
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      setModalCancelar(true);
                      setDniCancelar(turno.dni);
                      setIdCancelar(turno.id);
                    }}
                  >
                    Cancelar Turno
                  </MenuItem>
                )}
              </Menu>
            </>
          }
          title={turno.solicitante}
          subheader={turno.fechaHora}
        />
        <CardContent>
          <Grid container>
            <Grid item md={12}>
              {!turno ? (
                <>
                  <Skeleton animation={false} />
                  <Skeleton animation={false} />
                  <Skeleton animation={false} />
                </>
              ) : (
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <ListItemText primary={turno.servidor} />
                    </ListItemIcon>
                  </ListItem>
                </List>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default CardTurno;
